export default __webpack_public_path__ + "static/media/logo.46ca7176.png";